// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-pages-tests-MdmCardDemoPage-MdmCardDemoPage-module__box--bH0aN {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.src-pages-tests-MdmCardDemoPage-MdmCardDemoPage-module__content--OVaEg {
  flex: 1;
  overflow: auto;
}
.src-pages-tests-MdmCardDemoPage-MdmCardDemoPage-module__dataPane--AyirS {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.src-pages-tests-MdmCardDemoPage-MdmCardDemoPage-module__formPane--spN_v {
  height: 100%;
  overflow: hidden;
}
.src-pages-tests-MdmCardDemoPage-MdmCardDemoPage-module__textBox--qXkKa {
  flex: 1;
}
/*# sourceMappingURL=MdmCardDemoPage.module.css.map */`, "",{"version":3,"sources":["webpack://./MdmCardDemoPage.module.less","webpack://./src/pages/tests/MdmCardDemoPage/MdmCardDemoPage.module.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;ACCF;ADEA;EACE,OAAA;EACA,cAAA;ACAF;ADGA;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;ACDF;ADGA;EACE,YAAA;EACA,gBAAA;ACDF;ADGA;EACE,OAAA;ACDF;AACA,qDAAqD","sourcesContent":[".box {\n  height: 100%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.content {\n  flex: 1;\n  overflow: auto;\n}\n\n.dataPane {\n  height: 100%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n.formPane {\n  height: 100%;\n  overflow: hidden;\n}\n.textBox {\n  flex: 1;\n}\n",".box {\n  height: 100%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n.content {\n  flex: 1;\n  overflow: auto;\n}\n.dataPane {\n  height: 100%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n.formPane {\n  height: 100%;\n  overflow: hidden;\n}\n.textBox {\n  flex: 1;\n}\n/*# sourceMappingURL=MdmCardDemoPage.module.css.map */"],"sourceRoot":""}]);
// Exports
export var box = `src-pages-tests-MdmCardDemoPage-MdmCardDemoPage-module__box--bH0aN`;
export var content = `src-pages-tests-MdmCardDemoPage-MdmCardDemoPage-module__content--OVaEg`;
export var dataPane = `src-pages-tests-MdmCardDemoPage-MdmCardDemoPage-module__dataPane--AyirS`;
export var formPane = `src-pages-tests-MdmCardDemoPage-MdmCardDemoPage-module__formPane--spN_v`;
export var textBox = `src-pages-tests-MdmCardDemoPage-MdmCardDemoPage-module__textBox--qXkKa`;
export default ___CSS_LOADER_EXPORT___;
